<template>
  <div class="demo-split">
    <Split v-model="split1">
      <div slot="left" class="demo-split-pane">
        <TreeModel type="device" @on-select-change="onSelectChange" />
      </div>
      <div slot="right" class="demo-split-pane">
        <div class="head-view">{{ headTitle }}</div>
        <div class="btn-view">      
          <div class="from-view">
            <div class="from-label">{{ $t('alert.index.303927-0') }}</div>
            <Select v-model="query.pstate" :placeholder="$t('alert.index.303927-1')" style="width: 200px">
              <Option value="1">{{ $t('alert.index.303927-2') }}</Option>
              <Option value="2">{{ $t('alert.index.303927-3') }}</Option>
              <Option value="3">{{ $t('alert.index.303927-4') }}</Option>
            </Select>
          </div>
          <!-- <div class="from-view">
            <div class="from-label">设备编号：</div>
            <Input v-model="query.deviceCode" placeholder="请输入设备编号"></Input>
          </div> -->
          <div class="from-view">
            <div class="from-label">{{ $t('alert.index.303927-5') }}</div>
            <DatePicker
              v-model="query.dateList"
              type="daterange"
              show-week-numbers
              placement="bottom-end"
              :placeholder="$t('alert.index.303927-6')"
              style="width: 200px"
            ></DatePicker>
          </div>
          <Button
            type="primary"
            icon="ios-search"
            @click="GetDeviceAbnormalPageListWith3Code(1)"
            >{{ $t('alert.index.303927-7') }}</Button
          >
        </div>
    
        <VTabel
          :height="height"
          :columns="columns"
          :data="dataList"
          :total="query.total"
          :pageIndex="query.page"
          :loading="loading"
          @onPageChange="onPageChange"
          @onPageSizeChange="onPageSizeChange"
        ></VTabel>
      </div>
    </Split>
    
  </div>
</template>

<script>
import api from "../../../../api/request.js";
import Cookies from "js-cookie";
import VTabel from "@/components/components/VTable/index.vue";
import defaultData from "./columns.js";
import TreeModel from "../area/mods/tree.vue";

const URL = {
  GetDeviceAbnormalPageListWith3Code:
    "api/YhjStatic/GetDeviceAbnormalPageListWith3Code", // 设备告警
  ProcessUserDeviceAbnormal: "api/YhjDevice/ProcessUserDeviceAbnormal" // 操作
};
export default {
  components: {
    VTabel,
    TreeModel
  },
  data() {
    return {
      height: window.innerHeight - 270,
      split1: 0.2,
      query: {
        page: 1,
        size: 15,
        total: 0,
        deviceCode: "",
        dateList: "",
        startDt: "",
        endDt: "",
        pstate: 0,
      },
      loading: false,
      dataList: [],
      headTitle: this.$t('alert.index.303927-8'),
      parameter: '', // 参数
    };
  },
  computed: {
    columns() {
      return defaultData.columns(this);
    }
  },
  mounted() {
    this.getWindowInfo();
    window.addEventListener("resize", this.getWindowInfo);
    this.GetDeviceAbnormalPageListWith3Code();
  },
  methods: {
    onSelectChange(item) {
      this.parameter = "";
      this.headTitle = item.title;
      switch (item.grade) {
        case 1:
          this.parameter = `&Ccode=${item.Ccode}`;
          break;
        case 2:
          this.parameter = `&Vcode=${item.Vcode}`;
          break;
        case 3:
          this.parameter = `&Scode=${item.Scode}`;
          break;
        case 4:
          this.parameter = `&Zcode=${item.Zcode}`;
          break;
        case 5:
          this.parameter = `&RoomCode=${item.RoomCode}`;
          break;
        default:
          break;
      }
      this.query.page = 1;
      this.GetDeviceAbnormalPageListWith3Code();
    },
    getWindowInfo() {
      this.height = window.innerHeight - 270;
    },
    onPageChange(value) {
      this.query.page = value;
      this.GetDeviceAbnormalPageListWith3Code();
    },
    onPageSizeChange(value) {
      this.query.page = 1;
      this.query.size = value;
      this.GetDeviceAbnormalPageListWith3Code();
    },
    GetDeviceAbnormalPageListWith3Code(
      page = this.query.page,
      size = this.query.size
    ) {
      const { GroupCode, DepartmentCode, CompanyCode, IsAdmin } = JSON.parse(
        Cookies.get("AdminData")
      );
      const [startDt, endDt] = this.query.dateList;
      const date = startDt
        ? `&startDt=${this.getNowFormatDate(
            startDt
          )}&endDt=${this.getNowFormatDate(endDt)}`
        : "";
      this.loading = true;
      api(
        {
          //这里是你自己的请求方式、url和data参数
          method: "get",
          url: `${URL.GetDeviceAbnormalPageListWith3Code}?groupCode=${GroupCode}&companyCode=${CompanyCode}&departmentCode=${DepartmentCode}&deviceCode=${this.query.deviceCode}&deviceType=qg&pageIndex=${page}&pageSize=${size}&pstate=${this.query.pstate}&isAdmin=${IsAdmin}${date}${this.parameter}`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            Authorization: Cookies.get("Token")
          }
        },
        "yhj"
      )
        .then(res => {
          if (res.Success) {
            this.dataList = res.Data || [];
            this.query = {
              ...this.query,
              page,
              size,
              total: res.TotalCount
            };
          } else {
            this.$Message["error"]({
              background: true,
              content: res.Message
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 及时告警信息处理 type 2、处理 3、误报（yhj）
    SolveAbData(Id, type) {
      let _this = this,
        AdminData = JSON.parse(Cookies.get("AdminData"));
      _this.$Modal.confirm({
        title: this.$t('alert.index.303927-9'),
        content: `<p>是否对设备进行${type == 2 ? this.$t('alert.index.303927-11') : this.$t('alert.index.303927-4')}操作</p>`,
        onOk: () => {
          api(
            {
              //这里是你自己的请求方式、url和data参数
              method: "get",
              url: `${URL.ProcessUserDeviceAbnormal}?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&userDeviceAbnormal_Id=${Id}&pstate=${type}`,
              data: {},
              //假设后台需要的是表单数据这里你就可以更改
              headers: {
                "Content-Type":
                  "application/x-www-form-urlencoded;charset=UTF-8",
                Authorization: Cookies.get("Token")
              }
            },
            "yhj"
          ).then(res => {
            if (res.Success) {
              _this.$Message["success"]({
                background: true,
                content: res.Message
              });
              // 根据集团 公司 部门获取设备异常（yhj）
              _this.GetDeviceAbnormalPageListWith3Code();
            } else {
              _this.$Message["error"]({
                background: true,
                content: res.Message
              });
            }
          });
        },
        onCancel: () => {}
      });
    },
    // 获取日期
    getNowFormatDate(date) {
      let seperator1 = "-";
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      let currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    }
  }
};
</script>

<style scoped>
.demo-split {
  height: 100%;
  border: 1px solid #dcdee2;
}
.demo-split-pane {
  height: 100%;
  padding: 10px 20px;
  overflow-y: auto;
}
.btn-view {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 10px 0;
}
.from-view {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.from-label {
  text-align: right;
  font-weight: bold;
  margin-right: 10px;
}
.head-view {
  height: 40px;
  width: 100%;
  background-color: rgb(243, 245, 249);
  padding-left: 10px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/useGas/views/alert/index.vue